import { config } from '../../config';

/**
 * Removes stored tokens from the local storage.
 */
export function removeTokens() {
  localStorage.removeItem(config.embeddedFlowRefreshTokenStorageKey);
}
